import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import React from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import DatePickerLabel from 'components/common/DatePickerLabel';
import withConfirm from "hooks/withConfirm";
import { STATUS_EXERCISE as STATUS } from 'constant/timeline'

const TaskItem = ({ task, classes, handleDueDateChange, onStatusChange, confirm }) => {
  const { exercise, status, due_date } = task;
  const statusOptions = exercise.type === 'meeting' ? STATUS : STATUS.filter(i => i.value !== 'noshow');
  const handleStatusChange = (e) => {
    const { value } = e.target;
    if (value === 'done') {
      window.analytics.track(`Meeting ${value}`, {
        ...task
      });
      confirm(() => onStatusChange(task, value), {
        description: "You're marking this task as DONE. This cannot be undone.",
        confirmationText: 'Yes'
      })
    }
    else if (value === 'noshow') {
      window.analytics.track(`Meeting ${value}`, {
        ...task
      });
      confirm(() => onStatusChange(task, value), {
        description: "You're marking this task as NOSHOW. This cannot be undone.",
        confirmationText: 'Yes'
      })
    } else {
      onStatusChange(task, value);
    }
  };

  const handleDateChange = (val) => handleDueDateChange(task, val);

  const statusMenu = (
    <Select
      disableUnderline
      displayEmpty
      disabled={task.status === 'done' || task.status === 'noshow'}
      renderValue={(val) =>
        STATUS.find((s) => s.value === val)?.label || 'Select'
      }
      classes={{
        select: classes.select,
      }}
      value={status}
      onChange={handleStatusChange}
    >
      {statusOptions.map((i) => (
        <MenuItem
          classes={{ root: classes.menuItem }}
          key={i.value}
          value={i.value}
        >
          {i.label}
        </MenuItem>
      ))}
    </Select>
  );

  return (
    <TableRow>
      <TableCell>{exercise.name}</TableCell>
      <TableCell>{statusMenu}</TableCell>
      <TableCell>
        {exercise.type === 'meeting' ? null : (
          <DatePickerLabel
            value={due_date || null}
            onChange={handleDateChange}
          />
        )}
      </TableCell>
    </TableRow>
  );
};

export default withConfirm(TaskItem);
